import React, { Fragment } from 'react'
import uuidv1 from 'uuid/v1'
import ImmutablePropTypes from 'react-immutable-proptypes'

import PreviousCompletedProTrackLevel from './PreviousCompletedProTrackLevel'
import ProtrackLevel from './ProtrackLevel'

const ProTrackSection = ({ proTrack }) => {
  const isNextLevelExists = proTrack.getIn(['nextLevel', 'id'])
  const isPreviousLevelsExists = proTrack.get('previousLevels')
  if (isNextLevelExists && isPreviousLevelsExists) {
    return (
      <Fragment key={uuidv1()}>
        <ProtrackLevel protrackLevel={proTrack.get('nextLevel')} selectText="Select" />
        {proTrack
          .get('previousLevels')
          .map(previousLevel => (
            <PreviousCompletedProTrackLevel protrackLevel={previousLevel} key={uuidv1()} selectText={'Select'} />
          ))}
      </Fragment>
    )
  }
  if (isNextLevelExists && !isPreviousLevelsExists) {
    return (
      <Fragment key={uuidv1()}>
        <ProtrackLevel protrackLevel={proTrack.get('nextLevel')} selectText="Select" />
      </Fragment>
    )
  }
  if (!isNextLevelExists && isPreviousLevelsExists) {
    return (
      <Fragment key={uuidv1()}>
        <ProtrackLevel isFinished protrackLevel={proTrack.getIn(['previousLevels', 0])} selectText="Select" />
        {proTrack
          .get('previousLevels')
          .map(
            (previousLevel, i) =>
              i !== 0 && (
                <PreviousCompletedProTrackLevel protrackLevel={previousLevel} key={uuidv1()} selectText={'Select'} />
              )
          )}
      </Fragment>
    )
  }
  return null
}

ProTrackSection.propTypes = {
  proTrack: ImmutablePropTypes.contains({
    nextLevel: null,
    previousLevels: ImmutablePropTypes.list,
  }).isRequired,
}

export default ProTrackSection
